export const breakpoints = Object.freeze({
    xs: createBreakpoint(0),
    sm: createBreakpoint(576),
    md: createBreakpoint(768),
    lg: createBreakpoint(992),
    xl: createBreakpoint(1200)
});

function createBreakpoint<T extends number>(value: T): T {
    return value;
}
